var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{attrs:{"padding":""}},[_c('div',{staticClass:"row items-center justify-center q-pt-xl"},[_c('CarTypes',{staticClass:"card__type--order col-lg-6 col-sm-12"})],1),_c('LicencePlate')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }